<template>
  <div class="container-fluid mt--5 tbl-flt-sch">
    <div class="abs-btn-grp">
      <div v-if="selectedCount > 0" class="selection-chip align-self-center mr-2">
        <span class="selection-chip__count">Selected: {{ selectedCount }}</span>
        <button @click="clearSelection()" type="button" class="selection-chip__clear" title="Clear selection">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <!-- Table Search -->
      <!-- <form @submit.prevent="" class="d-inline-flex mt-0">
        <i @click="searchHolding()"  aria-hidden="true" class="fas fa-search active cursor-pointer"></i>
        <input v-on:keyup.enter="searchHolding" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" type="text" placeholder="Search Here" aria-label="Search" class="form-control form-control-sm ml-3 mr-3">
        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
      
      </form> -->

      <!-- <Button type="button" class="btn btn-warning"><i class="fas fa-cloud-upload-alt"></i> Import Holdings</Button> -->
      <div class="dropdown">
        <button :disabled="invUploadStatus == 'INPROGRESS' "  class="btn btn-warning rounded dropdown-toggle ml-2 mt-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <div v-if="invUploadStatus == 'INPROGRESS'" style="color:black">
            <i class="fa fa-spinner fa-spin"></i>  IMPORTING..
          </div> 
          <div v-if="!invUploadStatus">
            <i class="fas fa-upload"></i>  IMPORT
          </div>  
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item cursor-pointer" @click="openImportInventoryModal()">HOLDINGS</a>
          <a class="dropdown-item cursor-pointer" @click="openInvAccHoldingModal()">INVENTORY ACCOUNT HOLDINGS</a>
          <a class="dropdown-item cursor-pointer" @click="openAddInvModal()">ADD NEW</a>
        </div>
        <!-- <button @click="openAddInvModal()" type="button" class="btn btn-success rounded"><i class="fas fa-user-plus"></i> ADD NEW</button>               -->

      </div>
      <Button @click="sendToEcn()" type="button" class="btn btn-success"><i class="fas fa-paper-plane"></i> SEND TO ECN</Button>
      <!-- <Button type="button" class="btn btn-success" ><i class="fas fa-plus-circle"></i> Add New</Button> -->
      <!-- <Button type="button" class="btn btn-dark"><i class="fas fa-paper-plane"></i> Send All</Button> -->
    </div>
      <div class="row xsOnly">
        <div class="col-xl-12">
          <div class="card scrollbar vh-75" id="scroll">
            <div class="table-responsive">
              
                  <!-- <div class="row">
                      <div class="col-md-10"></div>
                      <div class="col-md-2">
                          <toggle-button v-model="isHoldingFilled" @change="onChangeEventHandler"/> Holding Filled
                      </div>
                  </div>  -->
                  <div class="sch-sticky d-flex" style="justify-content: space-between;">
                      <div>
                        <h6 class="d-flex justify-content-center ml-3">ECN Status</h6>
                     <div class="inventory-legend ml-4">
                          <span class="legend-color dark-green-legend" title="All ECN Sent"></span>
                          <span class="legend-color light-green-legend" title="Partial ECN Sent"></span>
                          <span class="legend-color dark-blue-legend" title="All Operator Sent"></span>
                          <span class="legend-color light-blue-legend" title="Partial Operator Sent"></span>
                          <span class="legend-color pink-orange" title="Inventory Offer Exists"></span>
                        </div>
                      </div>
                   <div class="input-group col-md-2 tab-sch tbl-sch rounded">
                      <input v-on:keyup.enter="searchHolding" type="text" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control rounded" placeholder="Search" />
                      <span v-if="searchValue" @click="clearSearch()" class="cursor-pointer input-group-text border-0"><i class="fas fa-times"></i></span>
                      <span @click="searchHolding()" class="cursor-pointer input-group-search border-0"><i class="fas fa-search"></i></span>
                  </div>
                  </div>
                  <table class="table align-items-center table-flush table-hover bidtbl bid-acc stkytbl-margin">
                      <thead class="thead-light psticky">
                      <tr >
                         <th 
                          scope="col" 
                          class="text-center"
                          >SELECT</th>
                        <th 
                        scope="col" 
                        class="sort text-left"
                        v-bind:class="[sortOrder == 'ASC' && sortColumn == 'customerAccount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'customerAccount'  ? 'sort-desc' : '']"  
                        @click="sort('customerAccount')" 
                        >CUSTOMER <br>ACCOUNT | TYPE</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusipDesc'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusipDesc'  ? 'sort-desc' : '']"  
                        @click="sort('cusipDesc')" 
                        >CUSIP/DESC</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        v-bind:class="[sortOrder == 'ASC' && sortColumn == 'coupon'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'coupon'  ? 'sort-desc' : '']"  
                        @click="sort('coupon')" 
                        >COUPON</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maturAndcallDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maturAndcallDate'  ? 'sort-desc' : '']"  
                        @click="sort('maturAndcallDate')" 
                        >MATURITY DATE/<br>CALL DATE</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        v-bind:class="[sortOrder == 'ASC' && sortColumn == 'rating'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'rating'  ? 'sort-desc' : '']"  
                        @click="sort('rating')"
                        >MOODY'S/ <br>S&P RATING</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bondInsurer'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bondInsurer'  ? 'sort-desc' : '']"  
                        @click="sort('bondInsurer')"
                        >INSURER</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == 'boughtDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'boughtDate'  ? 'sort-desc' : '']"  
                        @click="sort('boughtDate')"
                        >BOUGHT</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >COST</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >CLOSING PX</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >QTY</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >AVLB QTY</th>
                        <!-- <th 
                        scope="col" 
                        class="sort text-center"
                        >SETTLEMENT DATE</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >VALID TIME</th>-->
                        <th 
                        scope="col" 
                        class="sort text-left"
                        >SELL QTY</th> 
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >ACTION</th>
                      </tr>
                      </thead>
                      <tbody class="list">
                      <tr v-if="totalRows == 0 && !loading">
                          <td><p class="nodata">No data available</p>
                          </td>
                      </tr>
                      <tr v-for="holding in holdingsList" :key="holding.selectionKey"  >
                        <td class="text-center"  >
                          <input  v-model="holding.isSelect" @change="selectHolding(holding)" type="checkbox" class="form-check-input" />
                        </td>
                        <td class="text-left">
                            <span class="">{{holding.customerFirstName ? holding.customerFirstName[0] : ""}} {{holding.customerLastName}}</span><br>
                          <div v-for="inv in holding.invDetails"  :key="inv.id">
                                <span>{{inv.accountVal}}</span> | 
                                <span class="">{{inv.accountType}}</span>
                              </div>
                        </td>
                        <td class="text-center">
                            <span class="cusip-highlight" :class="getRowColor(holding.color)">{{holding.cusipVal}}</span><br>
                            <span data-toggle="tooltip" data-placement="left"  v-bind:title='holding.cusipDescription'>{{holding.cusipDescription | truncate(20, '...')}}</span>
                        </td>
                        <td class="text-center"><span>{{holding.coupon |  percent(3) }}</span></td>
                        <td class="text-center">
                          <span >{{holding.maturityDate ? moment(holding.maturityDate).format("MM/DD/YYYY") : "N/A"}}</span><br>
                        {{holding.callDate ? moment(holding.callDate).format("MM/DD/YYYY") : "N/A"}}
                        </td>
                        <td class="text-center"><span class="">{{holding.ratingMoody ? holding.ratingMoody : "N/A"}}</span>
                            <span class="insurer ">{{holding.ratingSP ? holding.ratingSP : "N/A"}}</span>
                        </td>
                        <td class="text-center"><span class="insurer">{{holding.bondInsurer ? holding.bondInsurer : "N/A"}}</span></td>
                        <td class="text-center">
                             <div v-if="holding.boughtDate">
                              <div v-for="(date, index) in holding.boughtDate.split(',')" :key="index">
                                {{ date }}
                              </div>
                            </div>
                        </td>
                        <td class="text-center">
                            <span class="">{{holding.cost | currency}}</span><br>
                        </td>
                        <td class="text-center">
                            <span >{{holding.closingPx}}</span><br>
                        </td>
                        <td class="text-center">
                            <span>{{holding.quantity}}</span><br>
                        </td> 
                        <td class="text-center">
                            <span>{{holding.remainQuantity}}</span><br>
                        </td>
                        <td class="text-center">
                            <span class="sell-qty"><input type="number" class="form-control" placeholder="Qty"  v-model.number="holding.sellQuantity"></span><br>
                        </td> 
                        <td class="text-center">
                          <button :disabled="!holding.sellQuantity"  @click="sendToEcnSingle(holding);selectedHolding = holding" type="button" class="btn btn-success" >SEND TO ECN</button>

                        </td>
                        </tr>
                      </tbody>
                      <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                  </table>
                  <!-- Pagination-->
                  <b-pagination
                      class="mt-4"
                      :total-rows="totalRows"
                      v-model="currentPage"
                      :per-page="perPage"
                      @input="getHoldingList(true)"
                  ></b-pagination>
                  <div class="total-records">
                      <span>Total Records : {{totalRows}}</span>
                  </div>
            </div>
          </div>
        </div>
      </div>
    <CreateBidWanted v-if="createBidWantedModalOpen" v-bind:holding="sendToEcnHoldings" v-bind:isOperatorDirectSendToEcn="true" @close="toggleCreateBidWantedModalOpen()" />
    <ImportInventory v-if="importInventoryModal" @close="closeImportInventoryModal()" />
    <ImporInventoryAccount v-if="importInventoryAccModal" @close="closeImportInventoryModal()" />  
    <AddNewInventory v-if="addInvModalOpen" v-bind:selectedInventory="{}" v-bind:mode="'ADD'" @close="closeAddInvModal()" />
    
  </div>    

</template>
<script>
import config from "@/config";
import authService from "@/authService";
// import Datepicker from 'vuejs-datepicker';
import CreateBidWanted from '../../ba-common/BaCreateBidWantedModal'
import ImportInventory from "@/components/ims/ims-inventory/ImsImportInventoryModal";
import ImporInventoryAccount  from "@/components/ims/ims-inventory/ImsImportInventoryAccountModal";
import AddNewInventory  from "@/components/ims/ims-inventory/ImsAddInventoryModal";

export default {
  name: "baAllHoldingsTrader",
  components : {
    // Datepicker,
    CreateBidWanted,
    ImporInventoryAccount,
    ImportInventory,
    AddNewInventory
    
  },
  data() {
    return {
        loading : false,
        currentPage: 1,
        perPage: 20,
        searchValue : "",
        totalRows : 0,
        sortColumn: "cusipDesc",
        sortOrder: "ASC",
        holdingsList : [],
        createBidWantedModalOpen : false,
        importInventoryModal : false,
        importInventoryAccModal : false,
        selectedHolding : null,
        addInvModalOpen : false,
        isHoldingFilled : false,
        invUploadStatus : localStorage.getItem("INVUPLOADSTATUS"),
        sendToEcnHoldings : [],
        selectedHoldingsMap : {}

        
    };
  },
  computed: {
    selectedCount(){
      return Object.keys(this.selectedHoldingsMap).length;
    }
  },
  methods: {
    selectionKey(holding, index){
      if(holding.id !== undefined && holding.id !== null){
        return "id-" + holding.id;
      }
      if(Array.isArray(holding.invDetails) && holding.invDetails.length > 0){
        return "inv-" + holding.invDetails.map(inv => inv.id).join("-");
      }
      return "row-" + this.currentPage + "-" + index;
    },
    selectHolding(holding){
      if(holding.isSelect){
        this.$set(this.selectedHoldingsMap, holding.selectionKey, holding);
      }else{
        this.$delete(this.selectedHoldingsMap, holding.selectionKey);
      }
    },
    clearSelection(){
      this.selectedHoldingsMap = {};
      this.holdingsList.forEach(holding => {
        holding.isSelect = false;
      });
    },
    // Keeps the checkboxes of previously selected rows ticked when a page is revisited.
    retainSelection(holdings){
      holdings.forEach((holding, index) => {
        holding.selectionKey = this.selectionKey(holding, index);
        if(this.selectedHoldingsMap[holding.selectionKey]){
          holding.isSelect = true;
          this.selectedHoldingsMap[holding.selectionKey] = holding;
        }
      });
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getHoldingList(true);
    },
    checkValid(holding){
      let isValid = true;
      let cusipType = holding.offeringTypeId === 1 ? "Munis" : "Corporates";
      if(!holding.sellQuantity){
        this.$alert("Fill all holdings sell quantity","","error");
        isValid = false;
        return;
      }
      if((holding.remainQuantity ) < holding.sellQuantity){
        this.$alert("Quantity entered is greater than available quantity.","","error");
        isValid = false;
        return;
      }
      if(cusipType == 'Munis' &&  holding.sellQuantity % 5 != 0 ){
        this.$alert("Holding quantity is not multiples of 5","","error");
        isValid = false;
       return ;
      }
      return isValid
    },
    sendToEcnSingle(holding){
      if(this.checkValid(holding)){
          this.sendToEcnHoldings = [];
          this.sendToEcnHoldings.push(holding);
          this.toggleCreateBidWantedModalOpen();    
      }
    },
     sendToEcn(){
      this.sendToEcnHoldings = Object.values(this.selectedHoldingsMap);
      if(this.sendToEcnHoldings.length == 0){
        this.$alert("Please select any holding","","error");
        return false
      }
      // const unique = [...new Set(this.sendToEcnHoldings.map(item => item.cusipVal))];
      // if(unique.length > 1){
      //   this.$alert("Please select holding with same cusip","","error");
      //   return false
      // }
      this.toggleCreateBidWantedModalOpen();
    },
    onChangeEventHandler(){
        this.getHoldingList(true); 
    },
    openAddInvModal(){
      this.addInvModalOpen = true;
    }, 
    closeAddInvModal(){
      this.addInvModalOpen = false;
      this.getHoldingList();
    },
    openImportInventoryModal(){
        this.importInventoryModal = true;
    }, 
    openInvAccHoldingModal(){
      this.importInventoryAccModal = true;
    }, 
    closeImportInventoryModal(){
      this.importInventoryModal = false;
      this.importInventoryAccModal = false;
      this.getHoldingList();
      this.invUploadStatus = localStorage.getItem("INVUPLOADSTATUS");


    },   
    toggleCreateBidWantedModalOpen(){
      this.createBidWantedModalOpen = !this.createBidWantedModalOpen;
      if(!this.createBidWantedModalOpen){
        this.getHoldingList();  
      }
    },
    searchHolding(){
      this.currentPage = 1;
      this.getHoldingList(true); 
    },
    clearSearch(){
      this.searchValue = "";
      this.currentPage = 1;
      this.getHoldingList(true); 
    },
    getHoldingList(keepSelection){
      this.loading = true;
        if(keepSelection !== true){
          this.clearSelection();
        }
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
          var postData = {};
          postData.page = this.currentPage;
          postData.size = this.perPage;
          postData.search = this.searchValue;
          postData.status = ['NEW'];
          postData.sortColumn = this.sortColumn;
          postData.sortOrder =  this.sortOrder;
          postData.listFilled =  this.isHoldingFilled;

        this.$http
        .post(
           config.baseUrlAutoBidder +
            "/bidwanted/inventory-listall",postData,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(holding => {
            holding.isOperatorDirectSendToEcn = true;
            holding.sellQuantity =  holding.remainQuantity ;
          });
          this.retainSelection(result.data.content);
          this.holdingsList = result.data.content;

          this.loading = false;
        }).catch(() => this.loading = false);
    }
  },
  mounted() {
    this.getHoldingList();
    this.$root.$on("INVUPLOADCOMPLETED", () => {
      this.invUploadStatus = null;
    });
  }
};
</script>
<style scoped>
/* Keep all toolbar actions on a single row when a selection is active */
.abs-btn-grp {
  max-width: min(72%, calc(100% - 60px));
  column-gap: 6px;
}

/* Compact selection indicator (replaces the bulky badge + full-width button) */
.selection-chip {
  display: inline-flex;
  align-items: center;
  height: 38px;
  padding: 0 4px 0 12px;
  background: #fff;
  border-radius: 5px;
  color: #303030;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
.selection-chip__count {
  line-height: 1;
}
.selection-chip__clear {
  border: 0;
  background: transparent;
  color: #9aa0a6;
  cursor: pointer;
  padding: 6px 8px;
  margin-left: 2px;
  line-height: 1;
  border-radius: 4px;
  transition: color 0.15s ease, background 0.15s ease;
}
.selection-chip__clear:hover {
  color: #e53935;
  background: #f2f2f2;
}

.sell-qty input{
  margin: auto;
}
</style>